import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteHotspotMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteHotspotMutation = { __typename?: 'RootMutationType', deleteHotspot?: { __typename?: 'ActionResult', userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const DeleteHotspotDocument = gql`
    mutation deleteHotspot($id: ID!) {
  deleteHotspot(id: $id) {
    userErrors {
      field
      message
    }
  }
}
    `;
export type DeleteHotspotMutationFn = Apollo.MutationFunction<DeleteHotspotMutation, DeleteHotspotMutationVariables>;

/**
 * __useDeleteHotspotMutation__
 *
 * To run a mutation, you first call `useDeleteHotspotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHotspotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHotspotMutation, { data, loading, error }] = useDeleteHotspotMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHotspotMutation(baseOptions?: Apollo.MutationHookOptions<DeleteHotspotMutation, DeleteHotspotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteHotspotMutation, DeleteHotspotMutationVariables>(DeleteHotspotDocument, options);
      }
export type DeleteHotspotMutationHookResult = ReturnType<typeof useDeleteHotspotMutation>;
export type DeleteHotspotMutationResult = Apollo.MutationResult<DeleteHotspotMutation>;
export type DeleteHotspotMutationOptions = Apollo.BaseMutationOptions<DeleteHotspotMutation, DeleteHotspotMutationVariables>;